module.exports = __webpack_public_path__ + "static/img/12003B_2_3_R_20190626_LC.7024b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12003B_2_3_R_20190626_LC.png
// module id = f8o3
// module chunks = 0